export default __webpack_public_path__ + "static/media/blue-coffee.9c7e6c7e.jpg";